import React, { useEffect, useRef, useState } from "react";
import Style from "./DoctorListingFilters.module.scss";
import Assets from "../Layout/Assets";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { CharacterSet } from "../Constants/characterSet";
import { object } from "yup";
import { Radio, Tooltip } from "antd";
function DoctorListingFilters({
  drListingResponse,
  filterForm,
  setFilter,
  setFilterkey,
  filterKey,
  ResetFilter,
  clientDetails,
}) {
  
const [hospitalData, sethospitalData] = useState([]);
  const locationData = useSelector((state) => state.doctorListing.location);
  const languageData = useSelector((state) => state.doctorListing.languagesSet);
  //const hospitalData = useSelector((state) => state.doctorListing.hospitals);
  const indexCharacters = useSelector(
    (state) => state.doctorListing.indexCharacters
  );

  const [showSelect, setSelect] = useState({
    byname: false,
    byGender: false,
    hospital: false,
    location: false,
    language: false,
  });
  useEffect(() => {
    drListingResponse?.Hospitals.forEach((item) => {
      if (item) {
        sethospitalData((prevData) => [...prevData, { value: item, checked: false }]);
      }
    });
  }, [drListingResponse]);

  // document.addEventListener("click", function (event) {
  //   var ignoreClickOnMeElement = document.getElementById("filterList");
  //   if (ignoreClickOnMeElement != null) {
  //     var isClickInsideElement = ignoreClickOnMeElement.contains(event.target);

  //     if (
  //       !isClickInsideElement &&
  //       (showSelect.byname ||
  //         showSelect.byGender ||
  //         showSelect.hospital ||
  //         showSelect.location ||
  //         showSelect.language)
  //     ) {
  //       //Do something click is outside specified element
  //       setSelect({
  //         byname: false,
  //         byGender: false,
  //         hospital: false,
  //         location: false,
  //         language: false,
  //       });
  //     }
  //   }
  // });

  const colDetailsDiv = classNames(Style.doctor_listing_details_div);

  const dropdownClassGender = classNames(
    Style.doctor_listing_byname,
    Style.doctor_listing_gender,
    filterForm?.gender !== "Gender" && Style.activeFilter
  );
  const dropdownClassHospital = classNames(
    Style.doctor_listing_byname,
    Style.doctor_listing_hospital,
    filterForm?.hospital.length > 0 && Style.activeFilter
  );

  const dropdownClassLocation = classNames(
    Style.doctor_listing_byname,
    Style.doctor_listing_location
  );
  const dropdownClassLanguage = classNames(
    Style.doctor_listing_byname,
    Style.doctor_listing_hospital,
    filterForm?.language.length > 0 && Style.activeFilter
  );

  const [submenu, setSubmenu] = useState({
    byname: false,
    byGender: false,
    hospital: false,
    location: false,
    language: false,
  });

  const [singleLanguageText, setSingleLanguageText] = useState("");
  const handlechange = (item, position, e) => {
    if (item.value === "All") {
      locationData.map((data) => {
        data.checked = e.target.checked;
      });

      delete filterKey?.city;
      if (e.target.checked) {
        setFilter({
          ...filterForm,
          location: ["All"],
        });
      } else {
        setFilter({
          ...filterForm,
          location: [],
        });
      }
    } else {
      locationData.map((data) => {
        if (data.value == item.value) {
          data.checked = e.target.checked;
        }
        if (data.value == "All") {
          data.checked = false;
        }
      });
      let selectedItem = [];
      locationData.map((obj) => {
        if (obj.checked == true && object.value !== "All") {
          return selectedItem.push(obj.value.toLowerCase());
        }
      });

      setFilter({
        ...filterForm,
        location: selectedItem,
      });
      if (selectedItem.includes("all") || selectedItem.length == 0) {
        delete filterKey.city;
      } else {
        setFilterkey({
          ...filterKey,
          city: selectedItem,
        });
      }
    }

    setSelect({ location: !showSelect.location });
  };

  const hospitalchange = (item, isChecked) => {
    if (item.value === "All") {
      hospitalData.map((data) => {
        data.checked = isChecked;
      });
      delete filterKey?.hospitalname;
      if (isChecked) {
        setFilter({
          ...filterForm,
          hospital: ["all"],
        });
      } else {
        setFilter({
          ...filterForm,
          hospital: [],
        });
      }
    } else {
      hospitalData.map((data) => {
        if (data.value == item.value) {
          data.checked = isChecked;
        }
        if (data.value == "All") {
          data.checked = false;
        }
      });

      let selectedItem = [];
      hospitalData.map((obj) => {
        if (obj.checked == true && object.value !== "All") {
          return selectedItem.push(obj.value.toLowerCase());
        }
      });
      setFilter({ ...filterForm, hospital: selectedItem });
      if (selectedItem.includes("all") || selectedItem.length == 0) {
        delete filterKey.hospitalname;
      } else {
        setFilterkey({ ...filterKey, hospitalname: selectedItem });
      }
    }
    setSelect({ hospital: !showSelect.hospital });
  };

  const languagechange = (item, isChecked) => {
    setSingleLanguageText("Single selection only");

    if (item.value === "All") {
      languageData.map((data) => {
        data.checked = isChecked;
      });

      delete filterKey?.languages;

      if (isChecked) {
        setFilter({
          ...filterForm,
          // language: ["All"],
        });
      } else {
        setFilter({
          ...filterForm,
          language: [],
        });
      }
    } else {
      languageData.map((data) => {
        if (data.value == item.value) {
          data.checked = isChecked;
        }
        if (data.value == "All") {
          data.checked = false;
        }
      });

      let selectedItem = [];

      languageData.map((obj) => {
        if (obj.checked == true && object.value !== "All") {
          return selectedItem.push(obj.value);
        }
      });
      setFilter({ ...filterForm, language: selectedItem });
      if (selectedItem.includes("all") || selectedItem.length == 0) {
        delete filterKey.languages;
      } else {
        setFilterkey({ ...filterKey, languages: selectedItem });
      }
    }
    setSelect({ language: !showSelect.language });
  };

  const change_gender = (e) => {
    setFilter({ ...filterForm, gender: e });
    setFilterkey({ ...filterKey, gender: e });
    setSelect({ byGender: !showSelect.byGender });
  };
  const Change_name = (e) => {
    setFilter({ ...filterForm, doctorName: e.target.value });
    setFilterkey({ ...filterKey, doctorName: e.target.value });
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setSelect({ byname: !showSelect.byname });
    }
  };

  const handleStarts = (name) => {
    setFilter({ ...filterForm, doctorName: name });
    setFilterkey({ ...filterKey, doctorName: name });
  };

  const getSample = (item, index) => {
    if (indexCharacters.includes(item)) {
      return (
        <li
          className={
            filterKey.doctorName == item
              ? "Style.selecetdIndex"
              : "not-selected"
          }
          key={index}
          onClick={() => handleStarts(item)}
        >
          {item}
        </li>
      );
    } else {
      return (
        <li
          key={index}
          className={Style.ActiveIndex}
          style={{ color: "#D1D1D1", cursor: "not-allowed" }}
        >
          {item}
        </li>
      );
    }
  };

  function capitalize(str) {
    if (str) {
      const lower = str.toLowerCase();
      return str.charAt(0).toUpperCase() + lower.slice(1);
    } else return null;
  }

  function onClickFilterItem(item) {
    setSelect({
      byname: false,
      byGender: false,
      hospital: false,
      location: false,
      language: false,
      [item]: !showSelect[item],
    });
  }


  console.log("hospitalData",hospitalData)

  return (
    <div
      className={colDetailsDiv}
      id="filterList"
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div className={Style.resetText}>
          <div onClick={ResetFilter}>
            {/* <img src={Assets.reset_icon} alt="" /> */}
            <span>Filter By</span>
          </div>
        </div>

        <div className={Style.resetText}>
          <div onClick={ResetFilter}>
            <img src={Assets.reset_icon} alt="" />
            <span>Reset Filter</span>
          </div>
        </div>
      </div>

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        <div
          className={classNames(
            Style.doctor_listing_byname,
            filterForm?.doctorName && Style.activeFilter
          )}
        >
          <span
            className={Style.filterNamelabelBox}
            onClick={() => onClickFilterItem("byname")}
          >
            <span className={Style.filterNamelabel}>
              Name{" "}
              {filterKey?.doctorName?.toLowerCase()?.charAt(0)
                ? `- ${filterKey?.doctorName?.toLowerCase()?.charAt(0)}`
                : ""}
              <img src={Assets.down_arrow} alt="" />
            </span>
          </span>

          {showSelect.byname && (
            <div className={Style.doctor_listing_byname_content}>
              <input
                autocomplete="off"
                id="search"
                placeholder="Search by Name"
                className={Style.doctor_listing_search_by_name}
                value={filterKey?.doctorName}
                onChange={Change_name}
                onKeyDown={handleKeyDown}
              />
              <ul>
                {CharacterSet &&
                  CharacterSet.map(
                    (item, index) => {
                      if (drListingResponse.indexCharacters.includes(item)) {
                        return (
                          <li
                            className={
                              filterKey?.doctorName?.toLowerCase()?.charAt(0) ==
                              item?.toLowerCase()
                                ? Style.SelectedIndex
                                : "not-selected"
                            }
                            key={index}
                            onClick={() => handleStarts(item)}
                          >
                            {item}
                          </li>
                        );
                      } else {
                        return (
                          <li
                            key={index}
                            className={Style.ActiveIndex}
                            style={{ color: "#D1D1D1", cursor: "not-allowed" }}
                          >
                            {item}
                          </li>
                        );
                      }
                    }
                    // return (
                    //   <li key={index} onClick={() => handleStarts(item)}>
                    //     {item}
                    //   </li>
                    // );
                  )}
              </ul>
              <img
                src={Assets.close_icon}
                alt=""
                onClick={() => onClickFilterItem("byname")}
              />
            </div>
          )}
        </div>

        <div className={dropdownClassGender}>
          <span
            className={Style.filterNamelabelBox}
            onClick={() => onClickFilterItem("byGender")}
          >
            <span className={Style.filterNamelabel}>{filterForm.gender}</span>
            <img src={Assets.down_arrow} alt="" />
          </span>

          {showSelect.byGender && (
            <div className={Style.doctor_listing_gender_content}>
              <div
                onClick={() => {
                  change_gender("Male");
                }}
                className={Style.doctor_listing_gender_content_male}
              >
                <input
                  type="radio"
                  value="Male"
                  name="gender"
                  checked={filterForm.gender === "Male"}
                  onChange={(e) => {
                    change_gender(e.target.value);
                  }}
                  id="male"
                />{" "}
                <label htmlFor="male"> Male</label>
              </div>{" "}
              <div
                onClick={() => {
                  change_gender("Female");
                }}
                className={Style.doctor_listing_gender_content_female}
              >
                <input
                  type="radio"
                  value="Female"
                  name="gender"
                  checked={filterForm.gender === "Female"}
                  onChange={change_gender}
                  id="female"
                />{" "}
                <label htmlFor="female"> Female</label>
              </div>
            </div>
          )}
        </div>

        {languageData && languageData.length > 0 && (
          <Tooltip placement="topLeft" title={filterForm.language[0]}>
            <div
              className={dropdownClassLanguage}
              onClick={() => onClickFilterItem("language")}
            >
              <span
                className={Style.filterNamelabelBox}
                onClick={() => onClickFilterItem("language")}
              >
                <span
                  className={Style.filterNamelabel}
                  // onClick={() => setSelect({ hospital: !showSelect.hospital })}
                >
                  {" "}
                  {filterForm.language?.length == 0
                    ? "Language"
                    : filterForm.language[0]}
                </span>
                <img
                  src={Assets.down_arrow}
                  alt=""
                  // onClick={() => setSelect({ hospital: !showSelect.hospital })}
                />
              </span>

              {showSelect.language && (
                <div
                  className={Style.doctor_listing_hospital_content}
                  onClick={() => onClickFilterItem("hospital")}
                >
                  {languageData &&
                    languageData.length !== 0 &&
                    languageData.map((item, index) => {
                      // console.log(filterForm.language, item.value);

                      return (
                        <div
                          className={Style.checkboxList}
                          onClick={() => {
                            languagechange(
                              item,
                              !filterForm.language.includes(item.value)
                            );
                          }}
                        >
                          <Radio
                            value={item.value}
                            id={item.value}
                            checked={filterForm.language.includes(item.value)}
                            onChange={(e) =>
                              languagechange(item, e.target.checked)
                            }
                          />
                          <label>{item.value}</label>
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          </Tooltip>
        )}

        {clientDetails?.clinicurl === "shalbys" && (
          <Tooltip
            placement="topLeft"
            title={capitalize(filterForm.hospital[0])}
          >
            <div
              className={dropdownClassHospital}
              onClick={() => onClickFilterItem("hospital")}
            >
              <span
                className={Style.filterNamelabelBox}
                onClick={() => onClickFilterItem("hospital")}
              >
                <span
                  className={Style.filterNamelabel}
                  // onClick={() => setSelect({ hospital: !showSelect.hospital })}
                >
                  {" "}
                  {filterForm.hospital?.length == 0
                    ? "Hospital"
                    : filterForm.hospital[0]}
                </span>
                <img
                  src={Assets.down_arrow}
                  alt=""
                  // onClick={() => setSelect({ hospital: !showSelect.hospital })}
                />
              </span>

              {showSelect.hospital && (
                <div
                  className={Style.doctor_listing_hospital_content}
                  onClick={() => onClickFilterItem("hospital")}
                >
                  {hospitalData &&
                    hospitalData.length !== 0 &&
                    hospitalData.map((item, index) => {
                      console.log( item.value);

                      return (
                        // <div className={Style.checkboxList} key={index}>
                        //   <input
                        //     type="radio"
                        //     value={item.value}
                        //     id={item.value}
                        //     checked={filterForm.hospital.includes(item.value.toLowerCase()) || filterForm.hospital.includes("all")}
                        //     // checked={item.checked}
                        //     onChange={(e) => hospitalchange(item, e)}
                        //   />
                        //   <label htmlFor={item.value}>{item.value}</label>
                        // </div>

                        <div
                          onClick={() => {
                            hospitalchange(
                              item,
                              !filterForm?.hospital.includes(item.value)
                            );
                          }}
                          className={Style.checkboxList}
                        >
                          <Radio
                            value={item.value}
                            id={item.value}
                            checked={filterForm?.hospital.includes(
                              item.value.toLowerCase()
                            )}
                            onChange={(e) =>
                              hospitalchange(item, e.target.checked)
                            }
                          />
                          <label>{item.value}</label>
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
}

export default DoctorListingFilters;
